import Modal from "./post/Modal";
import useDeleteModal from "../hooks/useDeleteModal";
import axios from "axios";
import { useState, useEffect } from "react";
import { FiAlertTriangle, FiTrash2 } from "react-icons/fi";

const DeleteModal = () => {
  const DeleteModal = useDeleteModal();
  const { config, isOpen, close } = DeleteModal;
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (isOpen) {
      setSuccessMsg("");
      setErrorMsg("");
    }
  }, [isOpen]);

  if (!config) return null;

  const {
    endpoint,
    payload,
    messages = {},
    onSuccess, // callback function (optional)
    onError,   // callback function (optional)
  } = config;

  const deleteThis = async () => {
    setIsLoading(true);
    setErrorMsg("");

    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_DOMAIN + endpoint,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          data: payload,
        }
      );

      if (response.status === 200) {
        setSuccessMsg(messages.success);
        if (onSuccess) onSuccess(response.data);
        setTimeout(() => close(), 1500);
      }
    } catch (error) {
      let errorMessage = messages.error;

      if (error.response?.data) {
        const err = error.response.data;
        if (Array.isArray(err?.error?.non_field_errors)) {
          errorMessage = err.error.non_field_errors[0];
        } else if (err?.message) {
          errorMessage = err.message;
        } else if (err?.detail) {
          errorMessage = err.detail;
        }
      }

      setErrorMsg(errorMessage);
      if (onError) onError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const content = (
    <div className="w-full p-1">
      <div className="flex flex-col items-center gap-4 mb-6">
        <div className="bg-red-50 rounded-full">
          <FiAlertTriangle className="h-10 w-10 text-red-600" />
        </div>

        <div className="text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-2 dark:text-white">
            {messages.warning}
          </h3>
          <p className="text-gray-600 dark:text-white">
            {messages.message}
          </p>
        </div>
      </div>

      {isLoading && (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      )}

      {successMsg && (
        <div className="flex flex-col items-center">
          <span className="text-green-600 dark:text-green-300">{successMsg}</span>
        </div>
      )}

      {errorMsg && (
        <div className="flex flex-col items-center">
          <span className="text-rose-900 dark:text-rose-400">{errorMsg}</span>
        </div>
      )}

      <div className="flex justify-end gap-3 pt-2">
        <button
          disabled={isLoading}
          onClick={close}
          className="list-btn"
        >
          {messages.cancel}
        </button>

        <button
          disabled={isLoading}
          onClick={deleteThis}
          className="flex gap-x-2 items-center cancel-btn"
        >
          <FiTrash2 className="h-4 w-4" />
          {messages.confirm}
        </button>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      label={messages.heading}
      content={content}
    />
  );
};

export default DeleteModal;
